import React from 'react';
import { Route } from "react-router-dom";
import EstablishmentsList from './establishments.list';
import EstablishmentView from './establishment.view';
import store from './filterStore';

const EstablishmentsRouter = ({ match }) => (
  <div>
    <Route path={`${match.path}/:id`} component={EstablishmentView} />
    <Route
      exact
      path={match.path}
      render={() => <EstablishmentsList store={store} />}
    />
  </div>
);

export default EstablishmentsRouter;
